import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";

const sampledatatableInit = {
  sampledatatables: {},
  isLoadingSampleDataTables: false,
};

function sampledatatablesReducer(draft, { type, payload }) {
  switch (type) {
    case "setSampleDataTables": {
      let newState = {}
      payload.DataTables.forEach(dt => {
        newState[[dt.id]] = dt
      })
      draft.sampledatatables = newState
      break;
    }

    case "setIsLoadingSampleDataTables": {
      draft.isLoadingSampleDataTables = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

const [SampleDataTableContext, SampleDataTableDispatchContext] = [
  createContext(null),
  createContext(null),
];

export default function SampleDataTableProvider({ init, children }) {
  const [sampledatatableStore, dispatch] = useImmerReducer(
    sampledatatablesReducer,
    init || sampledatatableInit
  );

  return (
    <SampleDataTableContext.Provider value={sampledatatableStore}>
      <SampleDataTableDispatchContext.Provider value={dispatch}>
        {children}
      </SampleDataTableDispatchContext.Provider>
    </SampleDataTableContext.Provider>
  );
}

export function useSampleDataTableStore() {
  return useContext(SampleDataTableContext);
}

export function useSampleDataTableDispatch() {
  return useContext(SampleDataTableDispatchContext);
}
